import { useEffect, useState } from 'react'
import { LayoutNarrowTwo, LayoutTwo } from '../../Layout/CommonStyle'
import JobClassList from './ClassList'
import { axiosGet } from '../../Common/Axios'
import { ApiResult } from '../../../models/Enums'
import { Result } from '../../../models/Dto/Result'
import { UserGroup } from '../../../models/UserGroup'
import Main from './Main'
import { ResultJobsEvaluationsDto } from '../../../models/Dto/ResultJobsEvaluationsDto'
import styled from 'styled-components'
import ResultJob from '../../Mentor/JobClass/ResultJob'
import ResultJobsPopup from '../../Mentee/JobClass/ResultJobsPopup'
import Pagination from '../../Common/Pagination'
import { useParams } from 'react-router'

interface ResultDto {
  data: ResultJobsEvaluationsDto[]
  total: number
  current: number
  totalElement: number
}

function AdminJobs() {
  const [resultJobsEvaluationsDtos, setResultJobsEvaluationsDtos] = useState<
    ResultJobsEvaluationsDto[]
  >([])
  const [totalPage, setTotalPage] = useState(10)
  const [currentPage, setCurrentPage] = useState(0)
  const [totalElement, setTotalElement] = useState(100)
  const [maxDisplayedPage] = useState(10)
  const [elementsPerPage] = useState(20)

  const [resultJobsEvaluationsDto, setResultJobsEvaluationsDto] = useState<
    ResultJobsEvaluationsDto | undefined
  >(undefined)
  const [isPopup, setIsPopup] = useState(false)

  const params = useParams()
  console.log('params', params)

  useEffect(() => {
    const page = params.page ? parseInt(params.page) : 0
    setCurrentPage(page)
    loadJobs(page)
  }, [params?.page])

  const loadJobs = async (current: number) => {
    const result = await axiosGet(
      `/api/jobs/get_result_jobs_statistics_page/${current}/${elementsPerPage}`
    )

    console.log(
      'loadJobs',
      result,
      'current',
      current,
      'pageSize',
      elementsPerPage
    )

    if (result.apiResult !== ApiResult.SUCCESS) {
      console.log('get_result_jobs_statistics error', result.message)
      return
    }

    console.log(result.data)
    setResultJobsEvaluationsDtos(result.data.data)
    setTotalPage(
      result.data.totalElement === 0
        ? 0
        : Math.floor((result.data.totalElement + 1) / elementsPerPage)
    )
    setCurrentPage(result.data.current)
    setTotalElement(result.data.totalElement)
  }

  return (
    <Container>
      {isPopup && (
        <ResultJobsPopup
          setIsPopup={setIsPopup}
          posterUrl={resultJobsEvaluationsDto?.resultJobs.posterUrl || ''}
        />
      )}
      <ResultJobs>
        {resultJobsEvaluationsDtos.map((resultJobsEvaluationsDto) => (
          <ResultJob
            key={resultJobsEvaluationsDto.resultJobs.id}
            resultJobsEvaluationsDto={resultJobsEvaluationsDto}
            resultJobsEvaluationsDtos={resultJobsEvaluationsDtos}
            setResultJobsEvaluationsDtos={setResultJobsEvaluationsDtos}
            setResultJobsEvaluationsDto={setResultJobsEvaluationsDto}
            setIsPopup={setIsPopup}
            useDelete={false}
          />
        ))}
      </ResultJobs>
      <Pagination
        url="/admin/jobs"
        currentPage={currentPage}
        setCurrentPage={setCurrentPage}
        totalPage={totalPage}
        maxDisplayedPage={maxDisplayedPage}
      />
    </Container>
  )
}

const Container = styled.div`
  width: 1000px;
  margin: 0 auto;
`
const ResultJobs = styled.div`
  padding: 40px 40px 40px 70px;
`

export default AdminJobs
